// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"88697da2","288":"d81abfb5","648":"f7275c16","804":"0080267c","854":"07043bb5"}[chunkId] + ".chunk.css";
};